import { render, staticRenderFns } from "./report-section.vue?vue&type=template&id=703ab7d3&scoped=true"
import script from "./report-section.vue?vue&type=script&lang=js"
export * from "./report-section.vue?vue&type=script&lang=js"
import style0 from "./report-section.vue?vue&type=style&index=0&id=703ab7d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703ab7d3",
  null
  
)

export default component.exports